import Api from './api'
import { AxiosResponse} from "axios";
import DynamicObject from "../models/dynamic-object";

export default (postId : number, type?: string, config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'post-stats'
    
    return Api.getInstance().request.get(`${path}/${postId}?types=${type || 'views,calls,bookmarks,rooms' }`, path)
}
